

























import Vue from 'vue';

import { Loading, Icon, Tooltip } from '@/components/ds';
import LoggedAccountConfirmation from '@/components/LoggedAccountConfirmation.vue';
import Home from '@/views/Home.vue';
import Analytics from '@/helpers/analytics';
import { isAccountConfirmed, saveConfirmedAccount } from '@/helpers/confirmedAccountStorage';
import VIEWS_NAMES from '@/router/viewsNames';
import accountsIframe from './helpers/accountsIframe';
import {
  hideEqualWebLaunchButtonUntilReady,
  installEqualWebLaunchButtonOffscreenStyle,
  showEqualWebDrawer,
} from './helpers/accessibility';
import { initVlibras } from './helpers/vlibras';

const equalWebSiteKey = 'aecf6ffe12fa1c1d26fe0ed3b1d39c4a';
const equalWebIntegrityKey =
  'sha512-3qLj5jbjMQnXk+FqEdVJjUnjJBGuBTRVOwaiT0ms6mQKQcrz4nulBxl2Hsr0/PpvEqdyJsMsU1NB+Mtfzw8hxA==';

export default Vue.extend({
  components: { Loading, Icon, Tooltip, LoggedAccountConfirmation, Home },
  data() {
    return {
      isLoading: false,
      isPreviewingAccount: false,
      isConfirmingAccount: false,
      confirmationAccount: { name: '', email: '' },
      onAccountConfirmation: null as ((confirmed: boolean) => void) | null,
    };
  },
  async created() {
    const isAuthenticated = Boolean(this.$cookies.get('admissions-auth-token'));
    this.isLoading = true;

    await new Promise((res: any) => {
      setTimeout(() => res(), 400);
    });

    const tokenD = accountsIframe.getTokenD();

    if (!isAuthenticated) {
      if (tokenD) {
        const email = accountsIframe.getEmailByPocket();

        // a sessão do navegador pode ser de outra pessoa; sem email não há o que conferir
        if (email && !isAccountConfirmed(email)) {
          const confirmed = await this.askAccountConfirmation(email);

          if (!confirmed) {
            accountsIframe.logout();
            // navega antes de fechar a prévia: o SignUp monta já sem a sessão
            await this.navigateToSignUp();
            this.closeAccountConfirmation();
            return;
          }

          saveConfirmedAccount(email);
          this.isLoading = true;
          this.closeAccountConfirmation();
        }

        try {
          await this.$store.dispatch('GET_USER', { email });

          const { user } = this.$store.getters;
          if (user) {
            await this.$store.dispatch('CREATE_AUTH_TOKEN');
          }
        } catch {
          this.navigateToSignUp();
          return;
        } finally {
          this.isLoading = false;
        }
      }
    }

    try {
      await this.$store.dispatch('PULL_CURRENT_ADMISSION');
      // antes do START_PIPELINE de propósito: é ele que produz a primeira navegação em
      // que os middlewares de fato avaliam a cidade.
      await this.$store.dispatch('RESTORE_SELECTED_CITY');
      await this.$store.dispatch('RESTORE_SELECTED_MODALITY');
      await this.$store.dispatch('PULL_PIPELINE');
      await this.$store.dispatch('START_PIPELINE');
    } catch {
      // suppress error
    } finally {
      const { user } = this.$store.getters;
      if (user) {
        const { email, name } = user;
        Analytics.identify({ id: email, email, name });
      }

      this.isLoading = false;
    }
  },
  mounted() {
    this.insertEqualWebScript();
  },
  methods: {
    insertEqualWebScript(): void {
      if ((window as any).descomplicaEqualWebInjected) {
        return;
      }
      (window as any).descomplicaEqualWebInjected = true;

      (window as any).interdeal = {
        sitekey: equalWebSiteKey,
        Position: 'Right',
        Menulang: 'PT',
        domains: {
          js: 'https://cdn.equalweb.com/',
          acc: 'https://access.equalweb.com/',
        },
        btnStyle: {
          vPosition: [null, '20%'],
          color: {
            main: '#2E850F',
            second: '#000000',
          },
          scale: [0.5],
          icon: {
            type: 1,
            shape: 'circle',
            outline: false,
          },
        },
      };

      const scriptElement = document.createElement('script');
      scriptElement.src = 'https://cdn.equalweb.com/core/5.3.1/accessibility.js';
      scriptElement.defer = true;
      scriptElement.integrity = equalWebIntegrityKey;
      scriptElement.crossOrigin = 'anonymous';
      scriptElement.setAttribute('data-cfasync', 'true');
      scriptElement.onload = () => {
        installEqualWebLaunchButtonOffscreenStyle();
        initVlibras();
      };

      hideEqualWebLaunchButtonUntilReady();
      document.body.appendChild(scriptElement);
    },
    askAccountConfirmation(email?: string): Promise<boolean> {
      const { name } = accountsIframe.getPocketProfile() || {};

      this.confirmationAccount = { name: name || '', email: email || '' };
      // não espera o banner de cookies: o modal reserva a área dele
      this.isPreviewingAccount = true;
      this.isLoading = false;
      this.isConfirmingAccount = true;

      return new Promise(resolve => {
        this.onAccountConfirmation = resolve;
      });
    },
    closeAccountConfirmation(): void {
      this.isConfirmingAccount = false;
      this.isPreviewingAccount = false;
    },
    resolveAccountConfirmation(confirmed: boolean): void {
      if (!this.onAccountConfirmation) return;

      this.onAccountConfirmation(confirmed);
      this.onAccountConfirmation = null;
    },
    navigateToSignUp(): Promise<unknown> {
      // já em /comecar, o NavigationDuplicated não é erro
      return Promise.resolve(this.$router.push({ name: VIEWS_NAMES.SIGN_UP })).catch(() => {});
    },

    navigateToSignIn() {
      this.$router.push({ name: VIEWS_NAMES.SIGN_IN });
    },
    showAccessibilityDrawer() {
      Analytics.track('Open accessibility drawer', {
        origin: 'Botão Acessibilidade',
      });

      showEqualWebDrawer();
    },
  },
});
